<script setup>
defineProps({
  count: { type: Number, default: 0 },
});
const emit = defineEmits(['open']);
</script>

<template>
  <button
    type="button"
    class="group fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 rounded-full bg-gradient-to-br from-blue-600 to-indigo-700 px-4 py-3 text-sm font-bold text-white shadow-xl shadow-blue-600/30 transition hover:scale-105 hover:shadow-2xl"
    @click="emit('open')"
  >
    <span class="i-lucide-sparkles size-4 transition group-hover:animate-pulse" />
    Copiloto
    <span
      v-if="count > 0"
      class="inline-flex min-w-[20px] items-center justify-center rounded-full bg-white px-1.5 text-[10px] font-bold text-blue-700"
    >
      {{ count }}
    </span>
  </button>
</template>
